import { Tag } from "antd";

export default function StatusButton({ status }) {
  const props = {
    active: {
      color: "#25A75D",
      backgroundColor: "#DEF8E9",
      label: "Active",
    },
    cancelled: {
      color: "#A72525",
      backgroundColor: "#FAEAEA",
      label: "Cancelled",
    },
    paused: {
      color: "#FA8642",
      backgroundColor: "#FEEFE6",
      label: "Paused",
    },
    expired: {
      color: "#FA8642",
      backgroundColor: "#FEEFE6",
      label: "Expired",
    },
  };

  return (
    <Tag
      style={{
        color: props[status].color,
        backgroundColor: props[status].backgroundColor,
        padding: "0.6rem 2rem",
        borderRadius: "4px",
        fontSize: "1rem",
        border: 0,
      }}
    >
      {props[status].label}
    </Tag>
  );
}
